/**
 * Created by sneaky on 2017-05-18.
 */
/**
 * Init
 */
// TODO: Only if mod 39 present.

updateParallaxPerspective();

// IE10 + IE11 polyfills
if(navigator.userAgent.indexOf('MSIE')!==-1
    || navigator.appVersion.indexOf('Trident/') > 0){

    $('.parallax__layer--wayback').css('transform','translateZ(-600px) scale(1.3)');
}


/**
 * Event handlers
 */
$(window).scroll(function (e) {
    updateParallaxPerspective();
    e.stopPropagation();
});

/**
 * Functions
 */
function updateParallaxPerspective() {

    $('.parallax-autofillbkg').each(function(){

        var paraOffset = $(this).offset().top;
        var paraHeight = $(this).height();
        var paraImgHeight = $(this).find('img').height();


        // Calculate relative scroll position.
        var relativePos = ($(window).scrollTop() + $(window).height() ) - (paraOffset + paraHeight);

        // Calculate fraction
        var vanishingPointFraction = (relativePos / ($(window).height()));

        // Calculate pixels
        var vanishingPointPercentagePixels = parseInt(vanishingPointFraction * paraImgHeight);


        // Calculate correction for moving larger images outside.
        var paraDiff = ((paraImgHeight )  / 2 ) - ((paraHeight   ) / 2);

        // Horisontal images fix.
        if(paraImgHeight < (paraHeight * 2 )){
            // Fixes horisontal, doesn't move them so much.
            vanishingPointPercentagePixels = vanishingPointPercentagePixels / 1.5;
        } else {
            // Fixes high images, moves them outside
            vanishingPointPercentagePixels -= paraDiff - ((parseInt(paraDiff * vanishingPointFraction)));
        }


        $(this).css('perspective-origin','50% ' + vanishingPointPercentagePixels + 'px');
    });


}